export default function initVirtualTours() {
    window.addEventListener('load', (event) => {
        intialiseVirtualTours()
    })

    const intialiseVirtualTours = () => {

        const VIRTUAL_TOURS = document.querySelectorAll('.virtual-tour')
        const IFRAME = document.querySelector('.iframe-wrapper iframe')
        const IFRAME_ERROR = document.querySelector('.iframe-wrapper .error')

        const loadFirstVirtualTour = (slide, index) => {
            if (index == 0) {
                changeVirtualTour(slide)
            }
        }

        const addClickEventListenersToVirtualTours = () => {
            VIRTUAL_TOURS.forEach((virtualTourSlide, index) => {

                loadFirstVirtualTour(virtualTourSlide, index)

                virtualTourSlide.addEventListener('click', (event) => {
                    changeVirtualTour(virtualTourSlide)
                })
            });
        }
        
        const changeVirtualTour = (virtualTourSlide) => {
            IFRAME_ERROR.style.display = "none"

            if (virtualTourSlide?.dataset?.url) {
                IFRAME.src = virtualTourSlide?.dataset?.url
                IFRAME.style.display = "block"
            }
            else {
                IFRAME_ERROR.style.display = "block"
                IFRAME.style.display = "none"
            }
        }

        addClickEventListenersToVirtualTours()
    }
}